import PipelineCancelled from './Charts/pipelineCancelled';
import PipelineFunded from './Charts/pipelineFunded';
import PipelineConversion from './Charts/pipelineConversions';
import CohortConversion from './Charts/cohortConversion';
import Leaderboards from './Charts/leaderboards';
import Birthdays from './Charts/birthdays';
import AMRs from './Charts/amr';

const chartMap = {
  'pipe-cancelled': PipelineCancelled,
  'pipe-fund-summary': PipelineFunded,
  'pipe-conversion': PipelineConversion, 
  'cohort-conversion': CohortConversion,
  'partner-leaderboard': Leaderboards,
  'borrower-bday': Birthdays,
  'amr': AMRs,
  // ...add more mappings as needed
};

export default function ReportChart({ reportType, data, filters, reportConfig }) {
  const ChartComponent = chartMap[reportType];

  if (!ChartComponent) {
    return <div className="text-muted">No chart available for this report.</div>;
  }

  return <ChartComponent data={data} filters={filters} reportConfig={reportConfig} />;
}